import programApi from '@features/programs/services/program-api';
import leadApi from '@features/leads/services/lead-api';
import {
  EditableDropdownCell,
  EditableDropdownCellEditMode,
  EditableDropdownCellItem,
  EditableDropdownCellViewMode,
  EditableDropdownCellViewModeItem,
} from '@shared/components/editable-dropdown-cell';
import { InfiniteList } from '@design-system/molecules/infinite-list';
import { deduplicateArr } from '@shared/utils/helpers/deduplicate-arr';
import { PROGRAM_STATUSES, type TProgram } from '@shared/types/program';

import type { TLead } from '@shared/types/lead';

export const LeadInterestedProgramsCell = ({ lead }: { lead: TLead }) => {
  const { mutate, variables } = leadApi.useUpdate();

  const optimisticPrograms = (variables?.tanstackMeta?.programs ??
    lead.programs) as TProgram[];

  return (
    <EditableDropdownCell>
      <EditableDropdownCellViewMode>
        {optimisticPrograms.length
          ? optimisticPrograms.map((program) => (
              <EditableDropdownCellViewModeItem key={program.id}>
                {program.name}
              </EditableDropdownCellViewModeItem>
            ))
          : '-'}
      </EditableDropdownCellViewMode>
      <EditableDropdownCellEditMode>
        <InfiniteList
          enableSearch
          fetchInfiniteData={programApi.useFetchInfinite}
          query={{ status: PROGRAM_STATUSES.active }}
          transformItems={(items) =>
            deduplicateArr([...optimisticPrograms, ...items], 'id')
          }
          props={{
            listProps: { className: 'gap-0 p-0' },
            listContainerProps: { className: 'p-1 max-h-[200px]' },
            searchContainerProps: { className: 'p-1 mb-1' },
            searchInputProps: {
              size: 'xs',
              className: 'text-sm placeholder:text-sm',
            },
          }}
          renderItem={(program) => {
            const isSelected = optimisticPrograms.some(
              (p) => p.id === program.id
            );

            const programs = isSelected
              ? optimisticPrograms.filter((p) => p.id !== program.id)
              : [...optimisticPrograms, program];

            return (
              <EditableDropdownCellItem
                type='checkbox'
                key={program.id}
                isSelected={isSelected}
                onClick={() => {
                  mutate({
                    id: lead.id,
                    programs: programs.map((p) => p.id!),
                    tanstackMeta: { programs },
                  });
                }}
              >
                {program.name}
              </EditableDropdownCellItem>
            );
          }}
        />
      </EditableDropdownCellEditMode>
    </EditableDropdownCell>
  );
};
